import React from 'react';
import { Box, Link, Stack, useTheme, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = ({ disableLinks = false }) => {
  const theme = useTheme();
  const muted = theme.palette.text.secondary;

  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        px: { xs: 2, sm: 3 },
        py: { xs: 1.25, sm: 1.5 },
        borderTop: (t) =>
          `1px solid ${
            t.palette.mode === 'dark'
              ? 'rgba(148,163,184,0.20)'
              : 'rgba(15,23,42,0.08)'
          }`,
        background: (t) =>
          t.palette.mode === 'dark' ? 'rgba(15,23,42,0.84)' : 'rgba(255,255,255,0.84)',
        backdropFilter: 'saturate(1.2) blur(8px)',
        zIndex: 3,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ 
            // maxWidth: 1000, 
            mx: 'auto', width: '100%' }}
      >
        {/* Левая группа ссылок */}
        <Stack
          direction="row"
          spacing={{ xs: 1.5, sm: 3 }}
          flexWrap="wrap"
          alignItems="center"
          sx={{ rowGap: 1 }}
        >
          <Link
            href="#"
            underline="hover"
            color={muted}
          >
            <Typography variant="body2" color={muted}>
              BillingService © 2024–{new Date().getFullYear()}
            </Typography>
          </Link>

          {/* <Link
            // href="https://vk.com/legal/recommendations"
            target="_blank"
            rel="noreferrer"
            underline="hover"
            color={muted}
          >
            <Typography variant="body2" color={muted}>
              Применяются рекомендательные технологии
            </Typography>
          </Link> */}

           <Link
            component={disableLinks ? 'a' : RouterLink}
            href={disableLinks ? '#' : undefined}
            to={disableLinks ? undefined : '/terms'}
            underline="hover"
            color={muted}
          >
            <Typography variant="body2" color={muted}>Пользовательское соглашение</Typography>
          </Link>

          <Link
            component={disableLinks ? 'a' : RouterLink}
            href={disableLinks ? '#' : undefined}
            to={disableLinks ? undefined : '/privacy'}
            underline="hover"
            color={muted}
          >
            <Typography variant="body2" color={muted}>Политика конфиденциальности</Typography>
          </Link>
        </Stack>

        {/* Правая группа ссылок */}
        <Stack
          direction="row"
          spacing={{ xs: 1.5, sm: 3 }}
          flexWrap="wrap"
          alignItems="center"
          sx={{ rowGap: 1 }}
        >
          {/* <Link
            href="https://ads.vk.com/business"
            target="_blank"
            rel="noreferrer"
            underline="hover"
            color={muted}
          >
            <Typography variant="body2" color={muted}>
              VK Реклама
            </Typography>
          </Link> */}
          <Link href={disableLinks ? '#' : 'mailto:privacy@billingservice.ru'} underline="hover" color={muted}>
            <Typography variant="body2" color={muted}>Связаться</Typography>
          </Link>
          <Link
            href="#"
            underline="hover"
            color={muted}
          >
            <Typography variant="body2" color={muted}>
              Разработчикам
            </Typography>
          </Link>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Footer;
